import { Injectable } from '@angular/core';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ITProyecto } from '../models/IProyectos.model'
//import { ITBancos } from '../models/ITBancos.model'

@Injectable({
    providedIn: 'root'
})

export class TFactorService {

    constructor(private apiService: ApiService) { }

    insertar(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.tfactor);
        return this.apiService.executePostJson(data).pipe();
    }

    actualizar(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.tfactor);
        return this.apiService.executePutJson(data).pipe();
    }


    eliminar(tipo: any, codfac: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.tfactor);
        return this.apiService.executeDeleteJson(`${tipo}/${codfac}`)
    }

    obtener(tipo: any, codfac: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.tfactor);
        return this.apiService.execGetQueryJson(`${tipo}/${codfac}`)
    }

    buscar(tipo: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.tfactor + 'buscar');
        return this.apiService.execGetQueryJson(`?tipo=` + (tipo != null ? tipo : ""))
    }

    actualizarDetraccion(data: any): Observable<any> {
        this.apiService.setUrlPathApi('registro-compras/actualiza-detraccion');
        return this.apiService.executePutJson(data).pipe();
    }
}
